<template>
    <GatewayGamesMain title="Live Casino" category="live_casino" />
</template>

<script>
import GatewayGamesMain from '@/components/slots/GatewayGamesMain.vue';

export default {
    name: 'LiveCasino',
    components: {
        GatewayGamesMain
    },
    metaInfo: {
        title: 'Live Casino - Casino Games'
    }
};
</script>

